import { useQuery } from "@tanstack/react-query";
import AccessManagementClient from "../../clients/AccessManagementClient";

const MAX_RETRIES = 1;

// Client errors (4xx) will not succeed on retry, so surface them immediately.
const shouldRetry = (failureCount, error) => {
  const status = error?.response?.status;
  if (status >= 400 && status < 500) return false;
  return failureCount < MAX_RETRIES;
};

/**
 * @param {string} dealerCommonId
 * @param {{ enabled?: boolean }} [options] pass enabled=false to defer the
 *   request (e.g. until an accordion is opened).
 */
export function useRoleUsers(dealerCommonId, { enabled = true } = {}) {
  const query = useQuery({
    queryKey: ["roleUsers", dealerCommonId],
    queryFn: () => AccessManagementClient.getRoleUsers(dealerCommonId),
    enabled: !!dealerCommonId && enabled,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: shouldRetry,
    retryDelay: 500,
  });

  // React Query v4 reports isLoading=true for disabled queries without data;
  // only treat it as loading while a request is actually in flight.
  return { ...query, isLoading: query.isLoading && query.fetchStatus !== "idle" };
}

export default useRoleUsers;
